import moment from 'moment';
import { Base } from './_base.model';

export class GlobalFile extends Base {
  id: number;
  file: string;
  filename: string;
  form_file: string | ArrayBuffer;
  description: string;
  /** Display label for the file revision, e.g. v1.02 */
  version?: string;
  public: boolean;
  bureau: boolean;
  start_date: Date;
  end_date: Date;
  status: string;
  kb_status: boolean;

  deserialize(obj: any) {
    Object.assign(this, obj);
    if (this.start_date) {
      this.start_date = moment(this.start_date).toDate();
    }
    if (this.end_date) {
      this.end_date = moment(this.end_date).toDate();
    }
    return this;
  }

  visibleTo(): string[] {
    const visible_to: string[] = [];
    if (this.public) {
      visible_to.push('Public');
    }
    if (this.bureau) {
      visible_to.push('Bureau');
    }
    return visible_to;
  }

  visibleToAbbreviated(): string[] {
    const visible_to: string[] = [];
    if (this.public) {
      visible_to.push('Pub');
    }
    if (this.bureau) {
      visible_to.push('Sales');
    }
    return visible_to;
  }
}

export const TOPIC_VISIBILITY = {
  ALL: 'all',
  NONE: 'none',
  PUBLIC: 'public',
} as const;

export type TopicVisibility = typeof TOPIC_VISIBILITY[keyof typeof TOPIC_VISIBILITY];

export class File extends GlobalFile {
  topics: any[];
  bureaus: any[];
  products: any[];
  form_file: string | ArrayBuffer;
  speaker: boolean;
  topic_visibility?: TopicVisibility;
  start_date: Date;
  end_date: Date;
  status: string;
  category: string;
  client_levels: any[];
  event_id: string;
  contact_id: string;
  archived: boolean;
  upload_form_id: string;

  visibleTo(): string[] {
    const visible_to: string[] = [];
    if (this.public) {
      visible_to.push('Public');
    }
    if (this.speaker) {
      visible_to.push('Speaker');
    }
    if (this.bureau) {
      visible_to.push('Bureau');
    }
    return visible_to;
  }

  visibleToAbbreviated(): string[] {
    const visible_to: string[] = [];
    if (this.public) {
      visible_to.push('Pub');
    }
    if (this.speaker) {
      visible_to.push('Sp');
    }
    if (this.bureau) {
      visible_to.push('Sales');
    }
    return visible_to;
  }
}